export default {
      id: "unit_dashboard__ignition-usage",
      viewBox: "0 0 41 31",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__ignition",
      toString: function () {
        return this.url;
      }
    }